import { Menu } from "../../model";
import apiService from "../ApiService";

export const getMenu = () => {
  return apiService.get<Menu>({
    path: "public/menu",
    edito: true,
  });
};
